module.exports = __webpack_public_path__ + "static/media/branding_1080p_tr.78b9b9bf.png";